import { combineReducers, createStore } from 'redux';
import snackbarReducer from './snackbar';
import loadingReducer from './loading';
import productDisclaimersReducer from './productDisclaimers';

const reducer = combineReducers({
  snackbar: snackbarReducer,
  loading: loadingReducer,
  productDisclaimers: productDisclaimersReducer,
});

const store = createStore(reducer, {});

export default store;
